/**
 * Specific selectors
 */

const selectSubscriptionAccountList = (state) => state.getIn(['subscription', 'subscriptionAccountList']);
const selectSubscriptionTeamList = (state) => state.getIn(['subscription', 'subscriptionTeamList']);

export {
  selectSubscriptionAccountList,
  selectSubscriptionTeamList,
};
